/* import __COLOCATED_TEMPLATE__ from './phone-handover-deflect-escalation-form.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type {
  DeflectEscalationConfiguration,
  ScheduledConfigurationKey,
} from 'embercom/models/fin-voice/number-configuration';
import type FinVoiceConfigService from 'embercom/services/fin-voice-config-service';
import isValidUrl from 'embercom/lib/url-validator';
import { isValidEmail } from 'embercom/lib/email';

interface Args {
  form: any;
  configType: ScheduledConfigurationKey;
  handoverConfig?: DeflectEscalationConfiguration;
  predicatesSchedule?: string;
  refreshConfig: () => void;
}

export default class PhoneHandoverDeflectEscalationForm extends Component<Args> {
  @service declare finVoiceConfigService: FinVoiceConfigService;
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;

  get officeHoursSchedules() {
    return this.finVoiceConfigService.officeHoursSchedules;
  }

  get hasOfficeHoursSchedules() {
    return this.officeHoursSchedules.length > 0;
  }

  get schedule() {
    return this.args.handoverConfig?.config.schedule || this.args.predicatesSchedule;
  }

  get activeOfficeHoursScheduleLabel() {
    return this.officeHoursSchedules.find((schedule) => schedule.value === this.schedule)
      ?.description;
  }

  get chatUrl() {
    return this.args.handoverConfig?.config.chatUrl;
  }

  set chatUrl(value: string | undefined) {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.chatUrl = value;
    this.args.refreshConfig();
  }

  get hasValidChatUrl() {
    return this.chatUrl && isValidUrl(this.chatUrl) !== null;
  }

  get emailAddress() {
    return this.args.handoverConfig?.config.emailAddress;
  }

  set emailAddress(value: string | undefined) {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.emailAddress = value;
    this.args.refreshConfig();
  }

  get hasValidEmail() {
    return this.emailAddress && isValidEmail(this.emailAddress);
  }

  @action
  toggleCallDuringOfficeHours() {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.callDuringOfficeHours =
      !this.args.handoverConfig.config.callDuringOfficeHours;
    this.args.refreshConfig();
  }

  @action
  toggleOfferEmail() {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.offerEmail = !this.args.handoverConfig.config.offerEmail;
    this.args.refreshConfig();
  }

  @action
  toggleOfferChat() {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.offerChat = !this.args.handoverConfig.config.offerChat;
    this.args.refreshConfig();
  }

  @action
  setSchedule(value: string) {
    if (!this.args.handoverConfig) {
      return;
    }

    this.args.handoverConfig.config.schedule = value;
    this.args.refreshConfig();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::PhoneHandover::PhoneHandoverDeflectEscalationForm': typeof PhoneHandoverDeflectEscalationForm;
  }
}
